<template>
  <div>
    
  </div>
</template>

<script>
/* eslint-disable */
import p5 from 'p5/lib/p5.min.js';
import p5Sound from '../p5.sound'

export default {
  p5,
  name: 'p5component',
  props: ['sketch','data'],

  methods: {
    loadSketch: function() {
      this.myp5 = new p5(this.sketch(this, p5));
    },
    stopSketch: function() {
      if(this.myp5.stop) {
        this.myp5.stop();
      }
    }
  },

  data: function() {
    return {
      myp5: {}
    }
  },

  mounted() {
    this.loadSketch()
  },

  watch: {
    data: {
      handler: function(val, oldVal) {
        if(this.myp5.dataChanged) {
          this.myp5.dataChanged(val, oldVal);
        }
      },
      deep: true
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
